import React, { useState, useRef } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { Upload, Image as ImageIcon, Link, X } from 'lucide-react';
import { getMediaUrl } from '../Services/apiService';
import Swal from 'sweetalert2';

const ImageUpload = ({ value, onChange, onFileChange, label = "KAPAK RESMİ" }) => {
  const [dragActive, setDragActive] = useState(false);
  const [inputType, setInputType] = useState('URL'); // URL or FILE
  const inputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  const handleFile = (file) => {
    // Sıkıştırma ve dönüştürme işlemleri tek bir yerden, backend'den yönetilecek
    const reader = new FileReader();
    reader.onload = (e) => {
       onChange(e.target.result);
       if (onFileChange) onFileChange(file);
    };
    reader.readAsDataURL(file);
    setInputType('FILE');
  };

  return (
    <div className="mb-3">
       <div className="d-flex justify-content-between align-items-center mb-1">
          <Form.Label className="small fw-bold text-secondary mb-0">{label}</Form.Label>
          <div className="d-flex gap-2">
             <Button 
                variant={inputType === 'URL' ? 'primary' : 'light'} 
                size="sm" 
                className="py-0 px-2" 
                style={{fontSize: '0.7rem'}}
                onClick={() => setInputType('URL')}
             >
                <Link size={12} className="me-1"/> URL
             </Button>
             <Button 
                variant={inputType === 'FILE' ? 'primary' : 'light'} 
                size="sm" 
                className="py-0 px-2" 
                style={{fontSize: '0.7rem'}}
                onClick={() => setInputType('FILE')}
             >
                <Upload size={12} className="me-1"/> Yükle
             </Button>
          </div>
       </div>

       {inputType === 'URL' ? (
           <InputGroup>
             <InputGroup.Text className="bg-white"><Link size={16}/></InputGroup.Text>
             <Form.Control 
                placeholder="https://..." 
                value={value && !value.startsWith('data:') ? getMediaUrl(value) : (value || '')}
                onChange={(e) => {
                    const val = e.target.value;
                    const isVideoUrl = val.match(/(youtube\.com|youtu\.be|vimeo\.com|\.mp4|\.webm|\.ogg)$/i);
                    if (isVideoUrl) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Geçersiz URL',
                            text: 'Lütfen sadece resim bağlantıları giriniz. Video bağlantıları kabul edilmemektedir.',
                            confirmButtonText: 'Tamam'
                        });
                        return;
                    }
                    onChange(val);
                }}
                className="shadow-none"
             />
          </InputGroup>
       ) : (
          <div 
             className={`border rounded p-3 text-center position-relative ${dragActive ? 'bg-primary bg-opacity-10 border-primary' : 'bg-light'}`}
             onDragEnter={handleDrag}
             onDragLeave={handleDrag}
             onDragOver={handleDrag}
             onDrop={handleDrop}
             style={{borderStyle: 'dashed !important', transition: 'all 0.2s', cursor: 'pointer'}}
             onClick={() => inputRef.current.click()}
          >
             <input ref={inputRef} type="file" className="d-none" accept="image/*" onChange={handleChange} />
             <div className="text-muted small pointer-events-none">
                <Upload size={24} className="mb-2 opacity-50"/>
                <div>Resmi buraya sürükleyin veya seçin</div>
             </div>
          </div>
       )}

       {value && (
          <div className="mt-2 position-relative rounded overflow-hidden border bg-light d-flex align-items-center justify-content-center" style={{height: 150}}>
             <img src={value.startsWith('data:') ? value : getMediaUrl(value)} alt="Preview" className="w-100 h-100 object-fit-contain" />
             <Button 
                variant="danger" 
                size="sm" 
                className="position-absolute top-0 end-0 m-2 rounded-circle p-1"
                onClick={() => {
                    onChange('');
                    if (onFileChange) onFileChange(null);
                }}
             >
                <X size={14}/>
             </Button>
          </div>
       )}
    </div>
  );
};

export default ImageUpload;
